import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
import AppContainer from './containers/App';
import * as serviceWorker from './serviceWorker';

// Set document title from environment variable (fallback to default)
const appTitle = process.env.REACT_APP_APP_TITLE || 'PodeSubir Backoffice';
if (typeof document !== 'undefined') {
  document.title = appTitle;
}

ReactDOM.render(
  <Provider store={store}>
    <AppContainer />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
